module.exports = __webpack_public_path__ + "fonts/ralewayitalic.825225f.woff";